
<div>
  <div class="row-no-margin section-header-container">
    <div class="col-md-10 clear-padding">
      <span class="section-header">News and Updates</span>
    </div>
    <div class="col-md-2 clear-padding" style="text-align:right;">

      <button  *ngIf="CurUser.IsTolomaticUser" class="blue" (click)="AddNewsItem()">Add New Item</button>

    </div>
  </div>
  <div class="col-md-12" style="justify-content:center;">
    <div *ngFor="let news of NewsList" class="infoCenterTile row-no-margin">
      <!--Filename-->
      <div class="col-md-4 clear-padding">
        <span style="font-size:15px;line-height:20px;">Updated {{news.UpdatedDate | date: 'short'}}</span>
        <br />
        <span style="font-size:17px; line-height:20px;font-weight:500;">{{news.Title}}</span>
      </div>
      <!--File Type/Category-->
      <div class="col-md-2 clear-padding" style="text-align:center;">
        <span class="clickable blue-color" (click)="GoToArticle(news)">Link To Article</span>
      </div>
      <div class="col-md-2 clear-padding" style="text-align:center;">
        <span style="font-size:15px;line-height:20px;font-weight:600;">{{news.Description}}</span>

      </div>
      <div class="col-md-4 clear-padding" style="text-align:right;">
        <fa-icon [icon]="faXmark" (click)="DeleteNewsItem(news)" class="clickable blue-color"></fa-icon>
        <span style="padding-right:10px;" title="Download">
          <fa-icon *ngIf="CurUser.IsTolomaticUser" [icon]="faPenToSquare" (click)="EditNewsItem(news)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
        </span>
        <span style="padding-left:10px;padding-right:10px;" title="Delete">
          <fa-icon *ngIf="CurUser.IsTolomaticUser" [icon]="faX" (click)="DeleteNewsItem(news)" class="fa-light fa-2x  clickable blue-color"></fa-icon>
        </span>
      </div>
    </div>

    <mat-paginator [length]="ItemCount" [pageSize]="PageSize" [pageSizeOptions]="PageSizeOptions" (page)="PageEvent($event)">
    </mat-paginator>
  </div>
</div>

